const dictToTranslationMap = (dict, oneLevel) => {
    const trMap = {};
    doItems(dict, trMap, oneLevel);
    return trMap;
}

const doItems = (items, trMap, oneLevel) => {
    for (let item of items) {
        trMap[item.value] = item.label
        if (!oneLevel && item.items && item.items.length > 0) {
            doItems(item.items, trMap, oneLevel)
        }
    }
}
export default dictToTranslationMap;